export const storeFormField = (data) => ({
  type: 'STORE_FORM_FIELD',
  data,
})

export const setFormData = (data) => ({
  type: 'SET_FORM_DATA',
  data,
})

export const clearForm = () => ({
  type: 'CLEAR_FORM',
})



// WEBPACK FOOTER //
// ./src/store/form/actions.js